import React from "react";

export default function RateandTerms() {
  return (
    <section className="w-full px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">

        {/* Heading */}
        <div className="text-center mb-10 sm:mb-12">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-semibold mb-4">
            <span className="text-[#F5A623]">Rates</span>{" "}
            <span className="text-black">and Fees</span>
          </h1>
        </div>

        {/* Key Details */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
          
          <InfoCard title="Monthly Interest Rate" value="2.9166%" />
          <InfoCard title="APR" value="35% (Fixed)" />
         <InfoCard 
          title="Tenure" 
          value="Minimum repayment period is 1 year and maximum repayment period is 3 years" 
        />

          <InfoCard title="Loan Amount" value="₹5,000 - ₹1,00,000" />
          <InfoCard title="Processing Fee" value="2%" />
          <InfoCard title="GST on Processing Fee" value="18%" />

        </div>

        {/* Representative Table */}
        <div className="overflow-x-auto">
          <h4>Representative Example</h4>
          <table className="w-full border border-gray-200 rounded-lg overflow-hidden">
            
            <thead className="bg-[#6C5CE7] text-white text-sm">
              <tr>
                <th className="p-3 text-left">Loan Amount</th>
                <th className="p-3 text-left">APR</th>
                <th className="p-3 text-left">Tenure</th>
                <th className="p-3 text-left">Processing Fee</th>
                <th className="p-3 text-left">GST</th>
                <th className="p-3 text-left">Amount Disbursed</th>
                <th className="p-3 text-left">EMI</th>
                <th className="p-3 text-left">Total Repayment</th>
                <th className="p-3 text-left">Total Interest</th>
              </tr>
            </thead>

            <tbody className="text-sm">
              <tr className="border-t">
                <td className="p-3">₹50,000</td>
                <td className="p-3">35%</td>
                <td className="p-3">12 Months</td>
                <td className="p-3">₹1,000</td>
                <td className="p-3">₹180</td>
                <td className="p-3">₹48,820</td>
                <td className="p-3">₹4,998</td>
                <td className="p-3">₹59,978</td>
                <td className="p-3">₹9,978</td>
              </tr>
            </tbody>

          </table>
        </div>

      </div>
    </section>
  );
}

/* Reusable Card */
function InfoCard({ title, value }) {
  return (
    <div className="p-4 border rounded-lg shadow-sm bg-white">
      <p className="text-gray-500 text-sm">{title}</p>
      <p className="text-lg font-semibold text-black mt-1">{value}</p>
    </div>
  );
}